import createModelInstance from 'utils/createModelInstance';

const Address = (addressInput) => {
    /**
     * Assign the data from an object coming from the Sugar API
     */
    let newAddressObj = {
        street: '',
        city: '',
        state: '',
        postalcode: '',
        country: 'Australia',
        lat: null,
        lng: null
    };

    const addressObj = {};
    // Creates the object from the API data format
    for (const key in addressInput) {
        if (key.includes('primary_address_')) {
            addressObj[key.replace('primary_address_', '')] = addressInput[key];
        } else {
            addressObj[key] = addressInput[key];
        }
    }

    newAddressObj = createModelInstance(newAddressObj, addressObj);

    return {
        ...newAddressObj,
        getAPIFormat() {
            return {
                primary_address_street: this.street,
                primary_address_city: this.city,
                primary_address_state: this.state,
                primary_address_postalcode: this.postalcode,
                primary_address_country: this.country,
                primary_address_lat: this.lat,
                primary_address_lng: this.lng
            };
        },
        getSingleLineAddress() {
            if (this.street && this.city) {
                return [this.street, this.city, this.state].join(', ');
            }
            return '';
        }
    };
};

export default Address;
